import React from "react";

const Feature3Skeleton = () => {
  return (
    <div className="w-full py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center">
        <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
          <div className="h-10 bg-gray-200 rounded-lg w-3/4 mb-6 animate-pulse"></div>
          <div className="h-6 bg-gray-200 rounded-lg w-full mb-4 animate-pulse"></div>
          <div className="h-6 bg-gray-200 rounded-lg w-5/6 mb-4 animate-pulse"></div>
          <div className="h-6 bg-gray-200 rounded-lg w-4/5 mb-8 animate-pulse"></div>
          <div className="h-12 bg-blue-200 rounded-lg w-40 animate-pulse"></div>
        </div>
        <div className="w-full lg:w-1/2 h-72 bg-gray-200 rounded-lg animate-pulse"></div>
      </div>
    </div>
  );
};

export default Feature3Skeleton;